import React, { useEffect, useState } from 'react';
import { fetchUsermedia } from '../services/influancerService';
import { FaHeart, FaComment, FaEye, FaShare, FaUsers, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import InfluencerLayout from '../dashboard/InfluencerLayout';
import LoadingSpinner from '../../components/LoadingSpinner';

const Media = () => {
  const navigate = useNavigate();
  const [mediaData, setMediaData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getMedia = async () => {
      try {
        const response = await fetchUsermedia();
        setMediaData(response.data.media);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching media:', err);
        setError('Failed to fetch Instagram media. Please try again later.');
        setLoading(false);
      }
    };
    getMedia();
  }, []);

  const handleBackClick = () => {
    navigate('/influencer/dashboard');
  };

  if (loading) {
    return <LoadingSpinner message="Fetching your Instagram Media..." />;
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-600 text-lg font-semibold">{error}</p>
      </div>
    );
  }

  return (
    <InfluencerLayout pageTitle="Media">
      <div className="min-h-screen bg-gray-100">
        <div className="container mx-auto px-4 py-8">
        <div className="flex items-center mb-6">
          <button className="" onClick={handleBackClick}>
            <FaArrowLeft className="h-6 w-6 text-gray-700" />
          </button>
          <h1 className="text-2xl lg:text-center font-bold mx-auto">Instagram Media</h1>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {mediaData.map((post) => (
            <div key={post.postId} className="bg-white border rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition duration-300">
              <img src={post.mediaUrl} alt={post.caption} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h2 className="text-lg font-semibold mb-2 truncate">{post.caption || 'No Caption'}</h2>
                <div className="flex flex-wrap items-center justify-between text-gray-600 text-sm">
                  <div className="flex items-center mr-2">
                    <FaHeart className="mr-1 text-red-500" />
                    <span>{post.insights?.likes || 0}</span>
                  </div>
                  <div className="flex items-center mr-2">
                    <FaComment className="mr-1 text-blue-500" />
                    <span>{post.insights?.comments || 0}</span>
                  </div>
                  {post.mediaType === 'VIDEO' && (
                    <div className="flex items-center mr-2">
                      <FaEye className="mr-1 text-green-500" />
                      <span>{post.insights?.views || 0}</span>
                    </div>
                  )}
                  <div className="flex items-center mr-2">
                    <FaUsers className="mr-1 text-purple-500" />
                    <span>{post.insights?.reach || 0}</span>
                  </div>
                  <div className="flex items-center mr-2">
                    <FaShare className="mr-1 text-yellow-500" />
                    <span>{post.insights?.shares || 0}</span>
                  </div>
                  <div className="flex items-center">
                    <span className="mr-1 font-bold">Total:</span>
                    <span>{post.insights?.total_interactions || 0}</span>
                  </div>
                </div>
                <p className="text-gray-500 text-xs mt-2">{new Date(post.timestamp).toLocaleString()}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
    </InfluencerLayout>
  );
};

export default Media;